import * as React from 'react';

import {RemoveButton} from '../button/remove-button/remove-button';
import {Dialog} from '../dialog/dialog';

import type {EmailSequence, NextEdition} from './email-sequence-progression';
import {ScheduledDetail} from './scheduled-detail';
import {SequenceProgress} from './sequence-progress';

import styles from './sequence-progression.module.css';

type Props = {
    emailSequence: EmailSequence;
    isDripSequence?: boolean;
    entityType: 'company' | 'lead' | 'person';
    nextEdition: NextEdition;
    sendTime: number;
    showPreviewModal: (arg1: string, arg2: string) => void;
    onCancelSequenceProgression: (id: string) => Promise<any>;
};

export function EmailSequenceListItem(props: Props) {
    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const deleteButtonRef = React.useRef();

    const {emailSequence: sequence, nextEdition, sendTime, entityType} = props;

    return (
        <div className={styles['sequence-list-item']}>
            <div className={styles['left-container']}>
                <SequenceProgress
                    htmlUrlPath={sequence.htmlUrlPath}
                    name={sequence.name}
                    totalSent={sequence.totalSent}
                    length={sequence.length}
                />
            </div>
            <div className={styles['right-container']}>
                <div className={styles['detail-container']}>
                    {props.isDripSequence && sequence.isPaused ? (
                        <div className={styles.detail}>This drip sequence is paused</div>
                    ) : (
                        <ScheduledDetail
                            editionId={
                                nextEdition.emailTemplate ? nextEdition.emailTemplate.id : undefined
                            }
                            name={nextEdition.name}
                            sendTime={sendTime}
                            entityType={entityType}
                            entity={sequence.entity}
                            showPreviewModal={props.showPreviewModal}
                        />
                    )}
                    <div className={styles['button-container']}>
                        {/* This span allows the remove button to turn red when the
                        detail-container is hovered to make it more visible */}
                        <span>
                            <RemoveButton
                                onClick={() => setIsConfirmingDelete(true)}
                                size={12}
                                tooltip='Remove'
                                getButtonRef={deleteButtonRef}
                            />
                        </span>
                    </div>
                </div>
            </div>
            {isConfirmingDelete ? (
                <Dialog
                    question={`Are you sure you want to cancel this ${
                        props.isDripSequence ? 'drip' : 'email'
                    } sequence? ${sequence.entity.name} will not receive the remaining messages.`}
                    primaryText='Yes, cancel messages'
                    secondaryText='No, don’t cancel'
                    isWarning={true}
                    anchor={deleteButtonRef.current}
                    location='top'
                    onSecondary={() => {
                        setIsConfirmingDelete(false);
                    }}
                    onPrimary={() => {
                        props
                            .onCancelSequenceProgression(sequence.id)
                            // @ts-expect-error
                            .then(setIsConfirmingDelete(false));
                    }}
                    customStyles={{width: '350px', maxWidth: 'unset'}}
                />
            ) : undefined}
        </div>
    );
}
